__turbopack_context__.v({
  "gradientBackground": "styles-module__Sb5T1W__gradientBackground",
  "heading": "styles-module__Sb5T1W__heading",
  "serefinContainer": "styles-module__Sb5T1W__serefinContainer",
  "signUpContainer": "styles-module__Sb5T1W__signUpContainer",
});
